import styles from './album-loader.module.css';

/** Main-content loading feedback. Inline artwork starts with CSS, before hydration or asset fetches. */
export function AlbumLoader({ label, size = 'default' }: { label: string; size?: 'default' | 'compact' }) {
  return (
    <div className={styles.loader} data-size={size} role="status" aria-live="polite" aria-atomic="true">
      <svg className={styles.art} width="160" height="144" viewBox="0 0 160 144" fill="none" aria-hidden="true" focusable="false">
        <ellipse className={styles.shadow} cx="80" cy="126" rx="38" ry="4" />
        <g className={styles.back}>
          <rect x="43" y="28" width="74" height="88" rx="5" fill="var(--loader-forest)" />
          <path d="M51 36h58v58H51z" fill="var(--loader-sage)" />
          <path d="M51 79c18-25 34-21 58-34v49H51z" fill="var(--loader-forest)" opacity=".45" />
        </g>
        <g className={styles.middle}>
          <rect x="43" y="28" width="74" height="88" rx="5" fill="var(--loader-coral)" />
          <path d="M51 36h58v58H51z" fill="var(--loader-peach)" />
          <circle cx="80" cy="65" r="19" fill="var(--loader-coral)" />
        </g>
        <g className={styles.front}>
          <rect x="42" y="28" width="76" height="90" rx="5" fill="var(--loader-edge)" />
          <rect x="42" y="26" width="76" height="90" rx="5" fill="var(--loader-paper)" stroke="var(--loader-edge)" />
          <path d="M50 34h60v60H50z" fill="var(--loader-sage)" />
          <circle cx="94" cy="49" r="8" fill="var(--loader-peach)" />
          <path d="M50 77c16-23 34-18 60-8v25H50z" fill="var(--loader-forest)" />
          <path d="M50 84c22 6 36-22 60-18v28H50z" fill="var(--loader-coral)" />
          <path d="M69 104h22" stroke="var(--loader-edge)" strokeWidth="2" strokeLinecap="round" />
          <path d="m107 26 11 11h-8a3 3 0 0 1-3-3z" fill="var(--loader-peach)" />
        </g>
      </svg>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
